import React, { useState } from 'react'
import video from '../../assets/videos/Prueba de Conocimientos - Concurso DEPG 2026.mp4'
import ReactPlayer from 'react-player'
import ubicacionesPdf from '../../assets/files/Concurso/UBICACION DE AULAS - CONCURSO DEPG 2026.pdf'
import entrevistasSabado from '../../assets/files/Concurso/Entrevistas Sabado.pdf'
import entrevistasPosterior from '../../assets/files/Concurso/Entrevistas a Posterior.pdf'
import { Dropdown } from 'react-bootstrap'

const ConcursoPrueba = () => {

  const [videoReadyStatus, setVideoReadyStatus] = useState(false);
  
  const toggleVideoStatus = () => {
    setVideoReadyStatus(true);
  }

  return (
    <div className='page-section instructivos prueba-con'>
        <section className='video-container'>
          <div className={`video-canvas ${ videoReadyStatus ? 'ready' : 'loading' }`}>
            <button 
              className={`video-placeholder btn btn-secondary disabled placeholder-wave d-${videoReadyStatus ? 'none' : 'block'}`} 
            ></button>
            <div className={`d-${ videoReadyStatus ? 'block' : 'none' }`}>
              <ReactPlayer
                className='video-player'
                url={video}
                playing={false}
                volume={0.2}
                controls={true}
                width={'100%'}
                height={'auto'}
                onReady={toggleVideoStatus}
              />
            </div>
          </div>
          <div className='button-group d-flex flex-column'>
            <a 
              href={ubicacionesPdf} 
              target='blank'
              // download={'Concurso 2025 Ubicación de Aulas'} 
              className='btn-baremo btn btn-primary link-button'
            >
              Ubicación de Aulas
            </a>
            {/* <Link to={'/ubicaciones-concurso'} target='blank' className='btn-baremo btn btn-primary link-button'>
              Consultar Ubicación
            </Link> */}
            <Dropdown className='entrevista-dropdown' drop='down-centered'>
              {/* <Dropdown.Toggle className='link-button w-100' variant="primary" id="dropdown-basic">
                Entrevistas
              </Dropdown.Toggle> */}

              <Dropdown.Menu>
                <Dropdown.ItemText className='link-button bg-primary'>
                  <a className='drop-link' href={entrevistasSabado} download={'Entrevistas Sábado - Concurso 2025 DEPGFMLUZ'} >
                    Entrevistas Sábado
                  </a>
                </Dropdown.ItemText>
                <Dropdown.ItemText className='link-button bg-primary'>
                  <a className='drop-link' href={entrevistasPosterior} download={'Entrevistas a Posterior - Concurso 2025 DEPGFMLUZ'} >
                    Entrevistas a Posterior
                  </a>
                </Dropdown.ItemText>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </section>

        <section className='info-container' id='index'>
          {/* <p className='heading-p'></p> */}
          
          <h3 className='section-title'>Examen de Conocimientos 2026</h3>
          
          <div className='info-group'>
            {/* <h3 className='modal-subtitle spaced'>Cronograma</h3> */}
            <p dangerouslySetInnerHTML={{__html: '<b>Fecha: </b> Sábado, 10 de octubre de 2026'}} />
            <p dangerouslySetInnerHTML={{__html: '<b>Hora: </b> 8:00 AM'}}/>
            <p dangerouslySetInnerHTML={{__html: '<b>Lugar:</b> Edificio Ciencia y Salud, Facultad de Medicina - La Universidad del Zulia'}}></p>
          </div>

          <div className='text-group-container mb-3'>
            <h3 className='modal-subtitle spaced'>Instrucciones importantes:</h3>
            {/* <h4 className='group-title'>Asistir con: </h4> */}
            <p
              className='continuous' 
              dangerouslySetInnerHTML={{__html: '<b>Consulta del aula:</b> En el archivo PDF adjunto encontrarán la distribución detallada de las aulas asignadas.'}}
            />
            
            <p>Ubiquen la especialidad y la unidad docente al que aspiran, para conocer el aula exacta donde deberán presentar la prueba. </p>

            <p
              dangerouslySetInnerHTML={{__html: '<b>Ruta de color:</b> Cada área del Edificio Ciencia y Salud estará identificada por un color, deberán seguir las señalizaciones para ubicarse de forma correcta. '}}
            />

            <p
              dangerouslySetInnerHTML={{__html: '<b>Video instructivo:</b> Es imprescindible que vean el video instructivo antes de asistir. En él se detallan las normas de ingreso, los materiales permitidos, fecha y hora del examen.'}}
            />

            <p>Les recomendamos llegar con suficiente anticipación y contar con su documento de identidad vigente a la mano.</p>

            <p>¡Mucho éxito en su proceso!</p>
          </div>
        </section>
    </div>
  )
}

export { ConcursoPrueba }